import pxToRem from "../functions/pxToRem";

// Plain 1px rules as in the reference; the "light" variant sits on the ink sidebar.
export default function divider({ tokens }) {
  const divider = {
    styleOverrides: {
      root: {
        backgroundColor: tokens.border,
        backgroundImage: "none !important",
        height: pxToRem(1),
        margin: `${pxToRem(16)} 0`,
        borderBottom: "none",
        opacity: 1,
      },

      vertical: {
        backgroundColor: tokens.border,
        backgroundImage: "none !important",
        width: pxToRem(1),
        height: "100%",
        margin: `0 ${pxToRem(16)}`,
        borderRight: "none",
      },

      light: {
        backgroundColor: tokens["ink-line"],
      },
    },
  };

  return divider;
}
